/**
 * Generated by orval v7.17.0 🍺
 * Do not edit manually.
 * FieldPay API
 * FieldPay API for managing organizations, opportunities, payouts and talent management
 * OpenAPI spec version: v1
 */
import * as zod from 'zod';


export const getFlaggedOrglessAccountsResponseItem = zod.object({
  "userId": zod.string().uuid(),
  "email": zod.string(),
  "displayName": zod.string(),
  "fullName": zod.string(),
  "businessName": zod.string().nullish(),
  "institutionName": zod.string(),
  "signedUpDate": zod.string().datetime({}),
  "linkedDate": zod.string().datetime({}),
  "flaggedDate": zod.string().datetime({}),
  "lastSeenDate": zod.string().datetime({}).nullish()
})
export const getFlaggedOrglessAccountsResponse = zod.array(getFlaggedOrglessAccountsResponseItem)

